import { CbNotificationToggle } from '../CbNotificationToggle/CbNotificationToggle';
import { CbUser } from '../CbUser';
import { ICON_BY_NAME } from '../Icons/Icon';
import styles from './PlayerItem.module.css';
import { Flipped } from 'react-flip-toolkit';
import { Player } from './types';
export const PlayerItem = ({
  player,
  onAdd,
  onRemove,
  disabled = false,
  notificationsForTeamID
}: {
  player: Player;
  onAdd?: (id) => void;
  onRemove?: (id) => void;
  disabled?: boolean;
  notificationsForTeamID?: number;
}) => {
  return <Flipped flipId={player.id} data-sentry-element="Flipped" data-sentry-component="PlayerItem" data-sentry-source-file="PlayerItem.tsx">
      <div className={styles.item}>
        <CbUser name={player.name} imageUrl={player.profileImage} data-sentry-element="CbUser" data-sentry-source-file="PlayerItem.tsx" />

        <div style={{
        flex: 1
      }} />

        {notificationsForTeamID && <CbNotificationToggle value={player.teams?.find(t => t.id === notificationsForTeamID)?.notificationsEnabled} userID={player.id as number} teamID={notificationsForTeamID} />}

        {!disabled && onAdd && <button type="button" data-testid={`add-${player.id}`} className={styles.add} onClick={() => onAdd(player)}>
            <ICON_BY_NAME.plus width="15px" height="15px" />
          </button>}
        {!disabled && onRemove && <button data-testid={`remove-${player.id}`} type="button" className={styles.remove} onClick={() => onRemove(player)}>
            <ICON_BY_NAME.closecircle width="15px" height="15px" />
          </button>}
      </div>
    </Flipped>;
};